import React, { useEffect, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import userimg from "../../../assets/img/user/user-4.jpg";

function DropdownProfile() {
	const [user, setUser] = useState(null);

	useEffect(() => {
	  const storedUser = localStorage.getItem("user");
	  if (storedUser) {
		setUser(JSON.parse(storedUser));
	  }
	}, []);

	//console.log("storedUser",user)

    const handleLogout = () => {
		localStorage.removeItem("authToken"); // Remove the stored token
		localStorage.removeItem("user"); // Remove user data
		window.location.href = "../"; // Redirect to login page
	  };

	return (
		<div className="navbar-item navbar-user dropdown">
			<a href="#/" className="navbar-link dropdown-toggle d-flex align-items-center" data-bs-toggle="dropdown">
				<img src={userimg} alt="" /> 
				<span>
					<span className="d-none d-md-inline fw-bold">Welcome, {user?.email || "Guest"}!</span>
					<b className="caret"></b>
				</span>
			</a>
			<div className="dropdown-menu dropdown-menu-end me-1">
			<Link to="#" onClick={handleLogout} className="dropdown-item">Log Out</Link>
			</div>
		</div>
	);
};

export default DropdownProfile;
